import { useJwtAuthenticatedApiClient } from '@guiker/react-framework'
import { JwtAuthenticatedApiClient } from '@guiker/tenant-application-shared'

export const useJwtTenantApplicationApiClient = useJwtAuthenticatedApiClient(JwtAuthenticatedApiClient)
